import { HorizontalRule } from 'admin-components/components';
import styled from 'styled-components';
import Button from 'components/ui/Button';
import { Page } from 'components/shared/Layout';
import ClubEurostarSVG from '../../assets/images/clubEurostar.svg';

import { colours } from 'themes/default';
import { BREAKPOINTS } from 'constants/breakpoints';

export const ConfirmButton = styled(Button)`
  div {
    align-items: center;
    display: flex;
  }
`;

export const StyledHorizontalRule = styled(HorizontalRule)`
  margin-top: 30px;
`;

export const StyledPage = styled(Page)`
  padding-bottom: 300px;

  @media (max-width: ${BREAKPOINTS.lg.max}px) {
    padding-bottom: 50px;
  }
`;

export const StyledConfirmButton = styled(Button)`
  div {
    align-items: center;
    display: flex;
  }
`;

export const StyledToggleButton = styled.button`
  cursor: pointer;
  text-decoration: underline;
  padding-right: 8px;
  display: flex;
  align-items: center;
  white-space: nowrap;
  background: transparent;
  outline: none;
  border: none;

  > svg {
    margin-right: 4px;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-gap: 1px;
  grid-template-columns: min-content min-content auto;
  background-color: white;
  border: 1px solid ${colours.Greyscale.SilverGrey};
  font-weight: normal;
  margin: 15px 0 15px 0;
  padding: 20px 0 20px 0;
`;

export const AvailablePointsCell = styled.div`
  background-color: white;
  color: ${colours.Greyscale.CharcoalGrey};
  font-size: 32px;
  line-height: 32px;
  font-weight: normal;
  padding: 5px 10px;
  white-space: nowrap;
`;

export const AvailablePointsBoldCell = styled.div`
  background-color: white;
  color: ${colours.Greyscale.CharcoalGrey};
  font-weight: bold;
  font-size: 32px;
  line-height: 32px;
  padding: 5px 10px;
  white-space: nowrap;
`;

export const ClubEurostarImg = styled.img`
  width: 32px;
  height: 32px;
`;

export const Error = styled.div`
  color: red;
`;

export const HereLink = styled.span`
  text-decoration: underline;
  cursor: pointer;
`;

export const StyledFareTypeContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;

  & > span {
    font-weight: 600;
  }
`;

ClubEurostarImg.defaultProps = {
  src: ClubEurostarSVG
};
